import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// The original site used plain <a href="*.php"> links between pages. Rather than
// rewriting every link inside the page markup, this component intercepts clicks
// on those links and turns them into client-side (SPA) navigations. Links to
// anything else (external sites, investor.php, the PHP endpoints, downloads,
// new tabs, modified clicks) are left untouched.
const PHP_ROUTES = new Set([
  "index.php",
  "about_us.php",
  "api_based_solutions.php",
  "package_solutions.php",
  "payment_solutions.php",
  "phonesystem_with_payments.php",
]);

export default function LinkInterceptor() {
  const navigate = useNavigate();

  useEffect(() => {
    function onClick(e) {
      if (
        e.defaultPrevented ||
        e.button !== 0 ||
        e.metaKey ||
        e.ctrlKey ||
        e.shiftKey ||
        e.altKey
      ) {
        return;
      }
      const anchor = e.target.closest && e.target.closest("a");
      if (!anchor) return;
      if (anchor.target && anchor.target !== "_self") return;
      if (anchor.hasAttribute("download")) return;

      const href = anchor.getAttribute("href");
      if (!href) return;

      let url;
      try {
        url = new URL(href, window.location.href);
      } catch {
        return;
      }
      if (url.origin !== window.location.origin) return;

      const base = url.pathname.split("/").pop();
      if (!PHP_ROUTES.has(base)) return;

      e.preventDefault();
      const to = (base === "index.php" ? "/" : "/" + base) + url.search + url.hash;
      navigate(to);
    }

    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, [navigate]);

  return null;
}
